import script from "./AddInsuranceMoreDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddInsuranceMoreDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddInsuranceMoreDetailsPage.vue?vue&type=style&index=0&id=04acf98a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04acf98a"]])

export default __exports__